import rowConfig from './rowConfig';
import { RowConfigsProps } from '../../types';

const getConfig = ({ columnsProps }: RowConfigsProps) => ({
  className: 'perpetuity-growth-terminal-table',
  rowConfig: rowConfig(columnsProps),
});

export default getConfig;
